var _defs, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g5, _g6, _g7, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404V2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0c1a68;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15 {\n        stroke-width: 0px;\n      }\n\n      .cls-16 {\n        stroke: #0c1a68;\n      }\n\n      .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-16, .cls-17, .cls-18, .cls-19, .cls-21, .cls-22, .cls-23, .cls-24 {\n        stroke-width: 4px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #000;\n      }\n\n      .cls-2, .cls-4, .cls-7, .cls-10, .cls-13 {\n        isolation: isolate;\n        opacity: .3;\n      }\n\n      .cls-4 {\n        fill: #0b6ca7;\n      }\n\n      .cls-17, .cls-20 {\n        stroke: #000;\n      }\n\n      .cls-18 {\n        stroke: #212121;\n      }\n\n      .cls-19 {\n        stroke: #030303;\n      }\n\n      .cls-5 {\n        fill: #9ca3af;\n      }\n\n      .cls-6 {\n        fill: #f3fafe;\n      }\n\n      .cls-7 {\n        fill: #626262;\n      }\n\n      .cls-20 {\n        stroke-width: 3px;\n      }\n\n      .cls-21 {\n        stroke: #474747;\n      }\n\n      .cls-8 {\n        fill: #fad1a8;\n      }\n\n      .cls-9, .cls-13 {\n        fill: #141414;\n      }\n\n      .cls-10 {\n        fill: #483623;\n      }\n\n      .cls-22 {\n        stroke: #483623;\n      }\n\n      .cls-23 {\n        stroke: #252525;\n      }\n\n      .cls-11 {\n        fill: #f3fafe;\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        fill: #4795c4;\n      }\n\n      .cls-24 {\n        stroke: #141414;\n      }\n\n      .cls-15 {\n        fill: #030303;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M556.2,818.3h-66.6v66.6h66.6v-66.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M523,868.4c9.3,0,16.9-7.6,16.9-16.9s-7.6-16.9-16.9-16.9-16.9,7.6-16.9,16.9,7.6,16.9,16.9,16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M704.2,625.8v186c0,5.3-1,10.5-3,15.3s-5,9.3-8.7,13c-3.7,3.7-8.1,6.7-13,8.7s-10.1,3-15.3,3h-141"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1178.7,376.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1168.8,366.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1066.8,272.2l60.3-46.1-84.9,14.1,34-107.9-99.8,95.4-26.6-103.7-18.9,82.8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M705.4,296c32.9,0,59.6-26.7,59.6-59.6s-26.7-59.6-59.6-59.6-59.6,26.7-59.6,59.6,26.7,59.6,59.6,59.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M714.4,208.2v31.1c0,5-4,9-9,9s-9-4-9-9v-31.1c0-5,4-9,9-9,5,0,9,4,9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M705.4,273.5c5,0,9-4,9-9s-4-9-9-9-9,4-9,9,4,9,9,9Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1075.8,968.6v-9.2c0-11.4-9.2-20.6-20.6-20.6h-117.5c-11.4,0-20.6,9.2-20.6,20.6v9.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1080.1,742.6h-167.4c-7.1,0-13,5.9-13,13s5.8,13,13,13h54.5v20.2h16.2v127.8h-16.3v22.1h58.2v-22.1h-15.9v-127.8h16.1v-20.2h54.6c7.1,0,13-5.9,13-13s-5.8-13-13-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M983.4,788.8h26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M983.4,916.6h26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M996.4,974.3v-35.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1075.5,990.7c9,0,16.4-7.3,16.4-16.4s-7.3-16.3-16.4-16.3-16.3,7.3-16.3,16.3,7.3,16.4,16.3,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1075.5,979.2c2.7,0,4.8-2.2,4.8-4.8s-2.1-4.8-4.8-4.8-4.8,2.2-4.8,4.8,2.2,4.8,4.8,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M996.2,990.7c9,0,16.4-7.3,16.4-16.4s-7.3-16.3-16.4-16.3-16.3,7.3-16.3,16.3,7.3,16.4,16.3,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M996.5,979.2c2.7,0,4.8-2.2,4.8-4.8s-2.2-4.8-4.8-4.8-4.8,2.2-4.8,4.8,2.2,4.8,4.8,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M916.7,990.7c9,0,16.4-7.3,16.4-16.4s-7.3-16.3-16.4-16.3-16.3,7.3-16.3,16.3,7.3,16.4,16.3,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M916.7,979.2c2.7,0,4.8-2.2,4.8-4.8s-2.2-4.8-4.8-4.8-4.8,2.2-4.8,4.8,2.2,4.8,4.8,4.8Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M825.1,302.8h0c7.3-8,22.8-23.2,23-23.9,1-1,6.7-54.1,17.8-52.6,4.4,0,6.4,3.6,7.1,5.4.2.4.7.5,1,.3,2.2-1.4,9.3-5.5,19.8-5.5,13.1.2,19.6,3,20.3,7.8,0,0,0,.1,0,.1,1.4.2,8.6,2.9,6.8,7.6q0,0,.1,0c1.1.4,8.4,3.5,5.8,7.6h0c.8.5,6.6,4.1,4.7,8-4.3,7.6-31.3,6-34.9,14.6-1.4,3.2-1.2,7.1-1.1,12,2.1,22.9-7.7,36.6-22.4,58.5,0,0,0,.1,0,0-1.6-.6-33-12.1-34.2-12.5h0l-13.9-27.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M790.6,934.2l-3.7-26.9c1.1-11.1-1-18-5.2-33.7,0,0-.7-5.8-.8-6.6q0,0,0,0l94.9-.2s0,0,0,0l3.5,6.9c2.1,20.4,3,41.1,2.5,61.3l-5.1,10.1h0c0,0-86.1-10.9-86.1-10.9q0,0,0,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M786.8,907.4q0,0,0,0h36.2c6.7,0,11.7,6,10.6,12.5l-2.8,15q0,.1,0,.1h50.9q0,0,0,0c-.3,11.5-1.2,23-2.4,34.4,0,0,0,0,0,0l-119.2,10.8h0l-19.7-10.7c0,0,0,0,0,0,13.2-18.7,43.3-23.6,46.5-62.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M879.5,969.7c-.8,7.1-1.7,14.2-2.9,21.2,0,0,0,0,0,0h-142.6q0,0,0,0c0-9,2.5-15.8,6.4-21.3h139.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M761.1,673c31.7-37.6,114.3-62.4,155.9-72.9,15.1-3.8,24-5.6,24.2-5.6h60.3c.9.9,22.9,23.3,29.7,61.1,8.1,46.5-27.7,87.8-75.1,87.8h-107.6c0,0,0,0,0,0,15.5,40.2,26.2,85.4,30.9,130q0,0,0,0h-92.2s-5.3,0-5.3,0c-15.2-54.2-54.9-159.7-20.5-200.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M850.7,682.4c-41.4,3.1-60.5,19-48.4,79.6,16.8,84,47.6,120.4,46.4,147.1-2,42.1-47.7,48.4-47.7,82l117.2-5.3c.1,0,0,0,0,0,.1-5.8,7.5-309-67.5-303.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M871.7,938.3l-5.4-31c0-11.2-1.6-19.6-5.9-33.7,0-.2,0-6.4,0-7.2s0,0,0,0l96.7-1.2h0l12.9,8.5h0c3.6,19.5,6.3,39.9,7.9,61.3l-1.1,11.3c0,0-.1,0-.1,0l-105-8q0,0,0,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M829.4,969.4c11.4-18.9,36.8-23.7,37-62q0,0,0,0h35.2c6.6,0,11.5,6,10.5,12.3l-2.5,15.3q0,.1,0,.1h68.2q0,0,0,0c.8,11,1.2,22.7,1.3,34.4,0,0,0,0,0,0-1.6.5-34.6,8.7-69.1,8.7s-78-8.2-80.7-8.8c0,0,0,0,0,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M828.8,673c43.2-51.3,179.2-78.2,180.1-78.4l86.3,3.1s0,0,0,.1c.3.8,3.1,10.1,6,23.1,2,9.3,4,20.4,5,31.8,4.6,53.2-35.1,90.9-82.4,90.9h-97.7c-.1,0-.1,0-.1,0,18.9,37.2,34.6,80.6,44.1,129.9q0,0,0,0h-109.4s-.1,0-.1,0c-17.5-57-66.9-158.7-31.7-200.6Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M907.2,710.8c-5-18.3,71.8,32.6,90.8,32.6h-72.1c-.5-1.1-8.5-16.8-18.7-32.6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M979.3,969.6c0,7,0,14.1-.2,21.3q0,0,0,0h-155.1q-.1,0-.1,0c0-9.1,2.1-15.8,5.5-21.3h150q0,0,0,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1168.4,537.5c-10.8-31.1-77.4-110.3-114.1-130.7h0c-23.8-11.5-51.9-12.6-52.6-12.6l-50.4.8-19.5,3.5c-12.3-2-52.5-5.9-75-7.8-8.3-.8-14.1-1.2-15.2-1.2s0-.1,0-.2c1.4-2,18.2-25.6,31.7-46.5h0c0,0-48.1-40-48.1-40h0c-21,21.3-43.7,44.6-53.3,56.4-9.7,11.9-14.3,28.3-12.4,43.6,2.2,17.7,12.9,34.1,30.8,47.4,8.1,6,16.8,11,25.7,15.4,35.9,17.4,74,22.2,75.8,22.4,0,0,0,0,0,0l25.2,111.9h0c0,0,178.9.2,178.9.2,0,0,0,0,0,0l-1-4.3c8,.6,15.7.9,22.9.9,23.9,0,40.1-3.5,45.7-9.8,5.8-6.5,14.3-21.8,4.8-49.3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M889.4,873.7l-106.4.3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M780.1,930.5l14.2,5.8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M771.4,942.2l11.6,9.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M916.2,725.2l9.8,18.2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M862.5,930.2l14.3,6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M854.5,943.3l10.9,8.5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M931.9,390.1v-7c0,0,0,0,0,0-1.6.4-19.7,4-31.4-6.8-14.5-14.7-4.9-43.4-6-63.6-.3-5-.2-9.9.3-14.2,3.2-29.9,24.7-34.8,60.4-34.2,41.7,1.4,44.6,23.2,45.9,38.2.4,12.9.3,37.7,0,57.8-.2,16.4.2,26.6.2,27.4h0c0,.1-7.3,6.3-7.3,6.3h0l-61.9-3.7c-.1,0-.2,0-.2-.1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M932.1,383q-.1,0,0,0v7.2c-.1,0-.1,4.6-.1,4.6q0,.1.1.1h4.7c0,0,.1,0,.1,0l16.4-19.9c0,0,0-.2,0,0-9.1,4.5-20.3,7.7-21.1,8Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M991,361.4c-5.9,0-13.7-1.5-18.5-8.2h0c1.3-1.3,22.8-22.8,12.7-35.6-2.7-3.5-6.4-5.2-11-5.2-9.6,0-20.2,7.8-20.8,8.3h0c-.9-.3-10.3-9.3-6.8-23.6,0-.1,0-.2-.2-.1-11.4,8.5-22.3,10-24.4-2.8,0-.1,0-.1-.2-.1-6.4,4.4-12.5,6.8-18.2,6.8-5.6-.1-8.6-1.9-8.8-2.4h0c1.4-30,26.6-42.1,59.6-41.5,70,0,47.3,100.5,46.8,103.1,0,0,0,0-.1,0-.3.1-4.6,1.1-9.9,1.1Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M951.8,397.8l-14.3,18.4c0,0-.2,0-.2,0l-5.5-17.8v-8.2q.1,0,.2,0l69.3-2.6q0,0,0,.1l.3,6.4h0c0,.1-33.4,24.4-33.4,24.4h0l-16.2-20.7h-.2Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M912,350.5c1.1-3.6,4.9-5.9,8.7-4.8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M913.6,327.9l-.3,2.7c-.2,1.8.6,3.5,2,4.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M928.5,320.5c3.9.1,3.9,5.9,0,6-3.9,0-3.9-5.9,0-6Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M902.3,320.5c3.9.1,3.9,5.9,0,6-3.9,0-3.9-5.9,0-6Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M951.3,431.8c8.4.2,8.4,12.5,0,12.7-8.3-.2-8.3-12.5,0-12.7Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M951.3,476.1c8.4.2,8.4,12.5,0,12.7-8.3-.2-8.3-12.5,0-12.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M951.3,520.4c8.4.2,8.4,12.5,0,12.7-8.3-.2-8.3-12.5,0-12.7Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M891.9,487.9l-4.1-24.6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M841.7,389.4l-13.6,18.3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M932,383c11.6-1.9,21.4-9.2,21.4-9.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M963.7,335l8.7-6.8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M873.4,232.3c-3.5,1.8-14,8.4-18.9,15.5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M914,234.3c-6.8-1-14.5-1.9-21.3-1-8.7,1.2-17.5,6.8-17.5,6.8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M926.9,249.7c-7.8,0-22.6.2-38,8.9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M921,242c-4.8,0-22.6-2.8-39,6.9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M827.9,407.6l13.5-18.2h0c.7,0,7.3.6,15.1,1.2,0,0,0,.1,0,.2l-28.5,16.9c-.2.1-.3,0-.2-.1Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M891.8,488c-2.4-.2-40-5.1-75.5-22.2,0,0,0-.2,0-.2,49.9-1.8,69.9-2.3,71.3-2.4q0,0,0,0l4.1,24.6h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1106,652.3c.1,0,.2,0,.2-.1-.7-8.6-2.7-21.2-5-31.5-1.9-9.2-4.5-18.3-5.2-20.5-.3-1-.9-3.9-1-4.4,0,0,0,0,0,0-16.7-1.2-34.4-3.4-49.8-6.3-10.1-1.9-19.3-3.9-26.1-5.6-.1,0,0,0,0,.2l-2.9,16c0,0,0,.3,0,.3h18.6c36.1,15.7,68.5,49.2,71.1,52Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1051.5,526.7c2.4,0,3.9.1,4.5.1s0-.1,0-.2c-6.4-8.3-14.7-18.5-21.4-30.3,0,0-.2,0-.2,0l-5.5,31.3c0,0,0,.2.1.2,2,0,4-.2,5.8-.3,7.1-.5,12.9-.8,16.5-.8Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1029,527.7c-16.8,1.2-37.9,4.1-53.9,11.2-22.4,9.5-66.3,43.5-49.3,44.4,3.1,0,11.7-4,15.9-6.2.5-.2,1,.4.6.8-5.5,6-20.5,23.8-6.6,24.5,2.5,0,4.9-.6,5.4-.7q0,0,0,0c2.5,10.5,15.8,4.6,18.7,1.5,0,0,.2,0,.2,0,0,3.3,4.1,5.6,8.4,5.4,9.1-.7,37.4-26.7,38.7-28.1h.1c.5.2,5,1.4,12,3.1,6.8,1.6,15.9,3.7,26,5.6q0,0,0,0c0-1.4,1.2-17.2-1.3-32.5-2.4-14.4-8.6-28.3-8.9-29.3h0c-1.9-.1-3.9,0-6,.2Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1034.7,496.3c7.4,11.8,12.9,19.7,21.6,30.4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M962.4,558.7c-6.8,5.1-15.2,13.7-21.4,19.6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M976,566.5s-27.1,26.6-34.9,35.3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M989.5,575.2l-29.6,28.1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M829.5,969.5c11.4-19,36.7-23.8,36.9-62.2,0-2.1,0-4.4-.2-6.8-.5-6.9-2.4-16-5.8-26.8-17.5-57.1-66.9-158.9-31.7-200.7,16.6-19.8,47.1-35.9,78.4-48.4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M737.9,972.9c2.8-5,7.1-9.1,11.5-12.8,4.7-3.9,9.7-7.7,14.4-11.6,10.4-8.7,19.1-18.7,21.8-32.3,2.9-14.5.5-29.8-4.1-43.7s-2-5.6-3.1-8.3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M970.1,873.7h-109.6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1035,527.4c20.4-1.9,66.8,1.2,66.8,1.2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1045.3,589.2c19.2,4.4,49.8,6.6,49.8,6.6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1285.3,616.5h-25.2v374.5h25.2v-374.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M670.8,616.5h-25.2v374.5h25.2v-374.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M614.8,602.5h702.2c1.7,0,3.3.3,4.8.9,1.5.6,2.9,1.6,4.1,2.7,1.2,1.2,2.1,2.6,2.7,4.1.6,1.5.9,3.2.9,4.8s-.3,3.3-.9,4.8c-.6,1.5-1.6,2.9-2.7,4.1-1.2,1.2-2.6,2.1-4.1,2.7-1.5.6-3.2,1-4.8,1h-702.2c-1.7,0-3.3-.3-4.8-1-1.5-.6-2.9-1.5-4.1-2.7-1.2-1.2-2.1-2.6-2.7-4.1-.6-1.5-1-3.2-1-4.8,0-1.7.3-3.3,1-4.8.6-1.5,1.6-2.9,2.7-4.1,1.2-1.2,2.6-2.1,4.1-2.7,1.5-.6,3.2-.9,4.8-.9Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1227.5,601.3v-146.2s53.7,0,53.7,0v146.2s-53.7,0-53.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1227.5,601.3v-146.2s53.8,146.2,53.8,146.2h-53.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1254.4,583.9c5.6,0,10.2-4.6,10.2-10.2s-4.6-10.2-10.2-10.2-10.2,4.6-10.2,10.2,4.6,10.2,10.2,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1174.3,601.3v-146.2s53.7,0,53.7,0v146.2s-53.7,0-53.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1174.3,601.3v-146.2s53.7,146.2,53.7,146.2h-53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1201.2,583.9c5.6,0,10.2-4.6,10.2-10.2s-4.6-10.2-10.2-10.2-10.2,4.6-10.2,10.2,4.6,10.2,10.2,10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1227.5,456v145.2"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M661.6,565.6c-16.6,0-33.8-13.5-38.3-30.2l-31.4-117.1c-2.2-8.3-1-16,3.4-21.8,4.2-5.5,10.9-8.5,18.8-8.5h188c16.7,0,33.8,13.6,38.3,30.3l31.4,117c2.2,8.3.9,16.1-3.5,21.8-4.2,5.5-10.8,8.5-18.6,8.5h-188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M763.7,565.6c0-.4,0-.8-.1-1.2,0-.4,0-.8,0-1.2-1.2-12.1-9.1-21.9-17.5-21.9-1.6,0-3.2.4-4.6,1-1.4.7-2.7,1.6-3.8,2.8-3.7,4.1-5.5,10.8-4.9,18l.3,2.3h-21s-4.7-48.5-4.7-48.5h72.9s4.8,48.6,4.8,48.6h-21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M683.9,603l23-86h73s-23,86-23,86h-72.9ZM736.7,541.4c-8.4,0-17.9,9.8-21.2,21.9-2,7.3-1.2,14.1,1.9,18.1.9,1.2,2,2.2,3.4,2.8,1.3.7,2.8,1,4.3,1,8.5,0,18-9.8,21.3-21.9,1.9-7.3,1.2-14.1-2-18.2-.9-1.2-2-2.1-3.3-2.8-1.3-.7-2.8-1-4.3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M699.6,432.8l4.6,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M721.1,432.8l4.6,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M742.6,432.8l4.6,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M789.9,603c0-1.7.3-3.4,1-5,.6-1.6,1.6-3,2.8-4.3,1.2-1.2,2.7-2.2,4.2-2.8,1.6-.7,3.3-1,5-1h156c3.5,0,6.8,1.4,9.3,3.8,2.5,2.5,3.8,5.8,3.8,9.3h0s-182.1,0-182.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M910.4,603c0-1.7.3-3.4,1-5,.7-1.6,1.6-3,2.8-4.3,1.2-1.2,2.7-2.2,4.2-2.8,1.6-.7,3.3-1,5-1h35.5c3.5,0,6.8,1.4,9.3,3.8,2.5,2.5,3.8,5.8,3.8,9.3h0s-61.7,0-61.7,0Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 824.5,
    y1: 991.5,
    x2: 976.5,
    y2: 991.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 735.5,
    y1: 989.5,
    x2: 819.5,
    y2: 989.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404V2);
export default __webpack_public_path__ + "static/media/404-v2.4589fecfcda253d683f64a86acbd7d28.svg";
export { ForwardRef as ReactComponent };